/**
 * Метод загрузки модуля кнопки для перехода в Яндекс карты
 * @kind helper
 * @returns Промис получения модуля
 */
export const loadControlsExtra = () => ymaps3.import('@yandex/ymaps3-controls-extra');
